import { OnInit } from '@angular/core';
import { BlogJuridicoService } from 'app/shared/services/wordpress/blog-juridico.service';
import { DomainService } from 'app/services/domain-service';
var ArticlesComponent = /** @class */ (function () {
    function ArticlesComponent(blogJuridicoService, domainService) {
        this.blogJuridicoService = blogJuridicoService;
        this.domainService = domainService;
        this.maxDescLength = 110;
        this.articulos = [];
    }
    ArticlesComponent.prototype.ngOnInit = function () {
        if (this.articulos && this.articulos.length > 0) {
            return;
        }
        var cats = this.blogJuridicoService.getCategoriasCompletas() || [];
        if (!cats.length) {
            return;
        }
        var flat = [];
        cats.forEach(function (cat) {
            var noticias = (cat.noticasListDestacadas && cat.noticasListDestacadas.length)
                ? cat.noticasListDestacadas
                : (cat.noticiasListAll || []);
            noticias.forEach(function (n) {
                flat.push({
                    id: n.id,
                    categoria: cat.titulo || '',
                    titulo: n.titulo || '',
                    desc: n.detalle || '',
                    imagen: n.imagen,
                    link: n.link
                });
            });
        });
        this.articulos = flat;
    };
    Object.defineProperty(ArticlesComponent.prototype, "items", {
        get: function () {
            return (this.articulos || []).slice(0, 3);
        },
        enumerable: true,
        configurable: true
    });
    ArticlesComponent.prototype.imagenUrl = function (articulo) {
        if (articulo && articulo.imagen && articulo.imagen.source_url) {
            return articulo.imagen.source_url;
        }
        return '';
    };
    ArticlesComponent.prototype.plainDesc = function (articulo) {
        if (!articulo || !articulo.desc) {
            return '';
        }
        var text = articulo.desc.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
        if (text.length <= this.maxDescLength) {
            return text;
        }
        var truncated = text.slice(0, this.maxDescLength);
        var lastSpace = truncated.lastIndexOf(' ');
        return (lastSpace > 0 ? truncated.slice(0, lastSpace) : truncated).trim() + '…';
    };
    ArticlesComponent.prototype.irA = function (articulo) {
        var url = this.urlArticulo(articulo);
        if (!url) {
            return;
        }
        window.open(url, '_blank');
    };
    ArticlesComponent.prototype.urlArticulo = function (articulo) {
        if (!articulo) {
            return '';
        }
        if (articulo.link) {
            return articulo.link;
        }
        if (articulo.id) {
            return this.domainService.wordpressJuridicoUrl + '/?p=' + articulo.id;
        }
        return '';
    };
    ArticlesComponent.prototype.verTodos = function () {
        window.open(this.domainService.wordpressJuridicoUrl, '_blank');
    };
    return ArticlesComponent;
}());
export { ArticlesComponent };
